import { styled, Switch } from '@mui/material';

import scssVariables from 'styles/sass-variables.module.scss';

export const SwitchStyled = styled(Switch)(() => ({
  width: 42,
  height: 24,
  border: `1px solid ${scssVariables.primary_purple_default}`,
  borderRadius: '13px',

  '&.Mui-focusVisible': {
    Animation: 'none',
  },
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 3.5,
    transitionDuration: '300ms',
    '& + .MuiSwitch-track': {
      backgroundColor: 'transparent!important',
      opacity: 1,
      border: 0,
    },

    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',

      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 16,
    height: 16,
    boxShadow: 'none',
    backgroundColor: `${scssVariables.primary_purple_default}`,
    transition: 'none',
  },
}));

export const switcherStyle = {
  display: 'flex',
  position: 'relative',
  justifyContent: 'space-between',
  width: '100%',
  height: '56px',
  marginBottom: '16px',
  padding: '16px 0',
  fontFamily: 'Plus Jakarta Sans, Manrope',
  borderRadius: '8px',
  border: `1px solid ${scssVariables.primary_purple_300}`,
  background: `${scssVariables.primary_purple_100}`,
};
